import React, { useEffect, useState, useRef } from 'react'
import { constants } from '../../constants';
import { isEmpty } from 'lodash';

const ExpandableText = ({ comment ,imageUrl,viewImage}) => {
    const fullText = comment;
    const [isExpanded, setIsExpanded] = useState(false);
    // This function is called when the read more/less button is clicked
    const toggleText = () => {
        setIsExpanded(!isExpanded);
    };
    return (
        <>
            {comment.length > constants.READ_MORE_LENGTH ? <p className='text'>
                {isExpanded ? fullText : `${fullText.slice(0, constants.READ_MORE_LENGTH)}...`}
                <span onClick={toggleText} className='readmore-button'>
                    {isExpanded ? 'Show less' : 'Show more'}
                </span>
            </p>
            // :(comment=='NA' && !isEmpty(imageUrl))?<><img  style={{height:30}} alt ="Image Preview" src={imageUrl.thumbnail} onClick={()=>viewImage(imageUrl.original)}/></>
             :<p>{comment}</p>}
        </>
    );
};
export default ExpandableText